/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum DashboardInvoiceWarningState {
  BookingSuspendedDueToOverdueInvoices = "BookingSuspendedDueToOverdueInvoices",
  BookingSuspendedDueToOverCreditLimit = "BookingSuspendedDueToOverCreditLimit",
  BookingWarningInvoicesCloseToOverdue = "BookingWarningInvoicesCloseToOverdue",
  BookingWarningCloseToCreditLimit = "BookingWarningCloseToCreditLimit",
  NoWarning = "NoWarning",
  BookingSuspendedNeedsAccountVerification = "BookingSuspendedNeedsAccountVerification",
  BookingSuspendedAccountOnHold = "BookingSuspendedAccountOnHold",
}

export function instanceOfDashboardInvoiceWarningState(value: any): boolean {
  for (const key in DashboardInvoiceWarningState) {
    if (
      Object.prototype.hasOwnProperty.call(DashboardInvoiceWarningState, key)
    ) {
      if (
        DashboardInvoiceWarningState[
          key as keyof typeof DashboardInvoiceWarningState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function DashboardInvoiceWarningStateFromJSON(
  json: any,
): DashboardInvoiceWarningState {
  return DashboardInvoiceWarningStateFromJSONTyped(json, false);
}

export function DashboardInvoiceWarningStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardInvoiceWarningState {
  return json as DashboardInvoiceWarningState;
}

export function DashboardInvoiceWarningStateToJSON(
  value?: DashboardInvoiceWarningState | null,
): any {
  return value as any;
}

export function DashboardInvoiceWarningStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DashboardInvoiceWarningState {
  return value as DashboardInvoiceWarningState;
}
